<template>
    <v-row>
      <v-form ref="form" style="width: 100%;">
        <template v-for="(section, i) in sections">
          <div :key="i" class="v-expansion-panel">
            <a v-if="idSection[i] !== 'userFields'"
              id="form-header"
              class="v-expansion-panel-header"
              @click="toggleCollapse(idSection[i])">
              <span class="d-flex align-center">
                <v-icon
                  left
                  v-bind:class="{ 'primary--text': !$vuetify.breakpoint.mdAndUp,
                  'icon__style': iconSection[i].includes('diraya') }">
                  {{ iconSection[i] }}
                </v-icon>
                {{ nameSection[i] }}
              </span>
              <v-divider style="width: 100%;" v-if="$vuetify.breakpoint.mdAndUp" />
            </a>

            <div class="v-expansion-panel-content" v-if="idSection[i] !== 'dirayaFields'">
              <div class="v-expansion-panel-content__wrap" v-show="collapsed[idSection[i]]">
                <v-row>
                  <template v-for="field in section.fields">
                    <Field
                      v-if="field.alias !== 'emailAddress'
                        && field.alias !== 'pass'
                        && field.alias !== 'tamano'"
                      class="panelContentSpace"
                      :ref="`field-${field.alias}`"
                      :key="field.sequence"
                      :eventBus="eventBus"
                      :expressionInterpreter="expressionInterpreter.interpreter(field.alias)"
                      :label="field.name"
                      :required="field.required"
                      :alias="field.alias"
                      :type="field.type.name"
                      :config="field.config"
                      :params="field.params"
                      :dependency="field.dependency"
                      :disabled="lock">
                    </Field>
                    <template v-if="field.alias === 'emailAddress'">
                      <Field
                        class="panelContentSpace"
                        :ref="`field-${field.alias}`"
                        :key="field.sequence"
                        :eventBus="eventBus"
                        :expressionInterpreter="expressionInterpreter.interpreter(field.alias)"
                        :label="field.name"
                        :required="field.required"
                        :alias="field.alias"
                        :type="userData.companyIsSAS
                          ? 'emailsas'
                          : 'email'"
                        :config="{
                          ...field.config,
                          disabled: userData.companyIsSAS
                            ? (userData.emailAddress ? 'true' : 'false')
                            : 'false',
                        }"
                        :params="field.params"
                        :dependency="field.dependency"
                        :disabled="lock">
                      </Field>
                    </template>
                    <template v-if="field.alias === 'pass'">
                      <div
                        class="panelContentSpace passContent col-md-4 col-lg-4 col-xl-3 col-12"
                        :key="field.sequence"
                      >
                        <v-text-field
                          class="inputPass"
                          :label="field.name"
                          :value="fechaPassMovil"
                          disabled
                        ></v-text-field>
                        </div>
                    </template>

                    <template v-if="field.alias === 'pass'">
                      <div
                        class="col-md-4 col-lg-4 col-xl-3 col-12 btn__pass--style"
                        :key="field.alias"
                      >
                        <div class="container__btnpass">
                          <v-btn
                            color="primary"
                            class="btn__pass"
                            :loading="loadingModifPass"
                            @click="modifPass"
                          >{{ $t('views.agescon.title') }}</v-btn>
                        </div>
                      </div>
                    </template>
                  </template>
                </v-row>
              </div>
            </div>
            <div class="v-expansion-panel-content" v-if="idSection[i] === 'dirayaFields'">
              <div v-if="treeData && treeData.length > 0"
                class="v-expansion-panel-content__wrap wrapper__diraya"
                v-show="collapsed[idSection[i]]">
                <v-treeview :items="treeData"></v-treeview>
              </div>

              <div class="v-expansion-panel-content__wrap" v-if="loading"
                :style="{height: '61.5px'}">
                <v-row>
                  <v-progress-circular
                    class="primary--text"
                    :style="{marginLeft: '2rem', marginBottom: '1rem'}"
                    indeterminate
                    ></v-progress-circular>
                </v-row>
              </div>

              <div class="v-expansion-panel-content__wrap"
              v-else-if="!loading && treeData.length === 0">
                <v-row>
                  <p  :style="{marginLeft: '1.3rem', marginBottom: '1rem'}">
                    {{ $t('formUserPerfil.dirayaModules.notDirayaModulesAssigned') }}
                  </p>
                </v-row>
              </div>
            </div>
          </div>
        </template>
      </v-form>
    </v-row>
  </template>

<script>
import Field, { FIELD_TYPES, EXTENDED_FIELD_TYPES } from './Field.vue';
import FormExpressionInterpreter from './form-expression-interpreter';
import '../../../public/style-cges.css';

const INPUT_TYPES = Object
  .values(FIELD_TYPES)
  .concat(
    Object.values(EXTENDED_FIELD_TYPES)
      .map((extendedFieldTypeEntry) => extendedFieldTypeEntry[1]),
  );

export default {
  props: {
    id: String,
    data: {
      type: Object,
      required: true,
    },
    buttons: {
      type: Array,
      default: () => [],
    },
    lock: {
      type: Boolean,
      default: () => false,
    },
    submitVisible: {
      type: Boolean,
      default: () => true,
    },
    profileViewForm: {
      type: Boolean,
      default: () => false,
    },
    nameSection: {
      type: Array,
      default: () => [],
    },
    iconSection: {
      type: Array,
      default: () => [],
    },
    idSection: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    Field,
  },
  data({ id, data }) {
    const listsectionForm = [];
    const { data: dataPerfil } = data;
    const dataPerfilArray = dataPerfil || [];
    dataPerfilArray.forEach((elem) => {
      if (!elem.id) {
        this.nameSection.push('');
        this.iconSection.push('');
        this.idSection.push('userFields');
      } else {
        this.nameSection.push(elem.name);
        this.iconSection.push(elem.icon);
        this.idSection.push(elem.id);
      }
      const sectionForm = elem.properties.reduce((tot, curr) => {
        const user = this.$store.getters['session/user'];
        const { fechaPassCaduca } = user;
        if (curr && curr.alias === 'pass' && fechaPassCaduca !== null) {
          this.showPass = true;
          const fechaCaduca = this.formatedDate(fechaPassCaduca);
          const days = this.calculateDate(fechaPassCaduca);
          if (days) {
            // eslint-disable-next-line no-param-reassign
            curr.config.initialvalue = `'${ fechaCaduca } (faltan ${ days } días)'`;
          } else {
            // eslint-disable-next-line no-param-reassign
            curr.config.initialvalue = '';
          }
        }
        const currSection = tot.length ? tot[tot.length - 1] : null;
        if (typeof (curr.config || {}).section === 'string') {
          if (currSection != null && currSection.section === curr.config.section) {
            currSection.fields.push(curr);
          } else {
            tot.push({ section: curr.config.section, fields: [curr] });
          }
        } else if (currSection != null && currSection.section == null) {
          currSection.fields.push(curr);
        } else {
          tot.push({ fields: [curr] });
        }
        return tot;
      }, []);
      listsectionForm.push(sectionForm[0]);
    });

    return {
      sections: listsectionForm,
      eventBus: this.$events.create(`form-${id}`),
      expressionInterpreter: new FormExpressionInterpreter({
        staticContextFields: {
          element: dataPerfilArray,
          user: this.$store.getters['session/user'],
        },
        getFieldsCtx: this.getFieldsCtx,
      }),
      btnDisabled: false,
      collapsed: {
        userFields: true,
        whatsappFields: false,
        dirayaFields: false,
        phoneFields: localStorage.getItem('from') === '/calltome',
        // personalInfo: false,
      },
      treeData: [],
      loadingModifPass: false,
      userData: {},
      userDataClient: null,
      fechaPassMovil: null,
      showPass: true,
      loading: false,
    };
  },
  computed: {
    isDesktop() {
      const desktop = window.matchMedia('screen and (min-width: 960px)');
      return desktop.matches;
    },
  },
  methods: {
    getFormData() {
      return Object.fromEntries(
        Object.entries(this.expressionInterpreter.fieldsContext)
          .filter((entry) => typeof entry[1].value !== 'undefined' && entry[1].value !== null && entry[1].value !== '')
          .map((entry) => [entry[0], entry[1].value]),
      );
    },
    getFormDataWithDeleted() {
      return Object.fromEntries(
        Object.entries(this.expressionInterpreter.fieldsContext)
          .filter((entry) => typeof entry[1].value !== 'undefined')
          .map((entry) => [entry[0], entry[1].value]),
      );
    },
    getFieldsCtx() {
      const $form = this.$children[0];
      const inputChildren = $form.$children
        .filter((child) => INPUT_TYPES.includes(child.component));

      return inputChildren.reduce((tot, curr) => {
        // const childData = curr.getContextData();
        // eslint-disable-next-line no-param-reassign
        tot[curr.alias] = curr.fieldValue;
        return tot;
      }, {});
    },
    validate() {
      return this.$refs.form.validate();
    },
    async submit(submitBtn) {
      const { form } = this.$refs;

      if (!form.validate()) {
        this.$nextTick(() => {
          const domRect = document.querySelector('.v-input.error--text').getBoundingClientRect();
          window.scrollTo(
            domRect.left + document.documentElement.scrollLeft,
            domRect.top + document.documentElement.scrollTop - 74,
          );
        });
        return false;
      }

      const formData = this.getFormDataWithDeleted();

      this.data.properties
        .filter((p) => p.type.name === 'hidden')
        .flatMap((p) => this.$refs[`field-${p.alias}`])
        .filter((p) => p.fieldValue.value != null)
        .forEach((p) => {
          formData[p.alias] = p.fieldValue.value;
        });

      const attachments = this.data.properties
        .filter((p) => p.type.name === 'file')
        .flatMap((p) => this.$refs[`field-${p.alias}`])
        .flatMap((fileField) => fileField.$children)
        .filter((fileComponent) => fileComponent.$vnode.componentOptions.tag === 'FileField')
        .flatMap((fileComponent) => fileComponent.files);

      this.$emit('click:submit', {
        action: submitBtn,
        data: formData,
        attachments,
      });
      return true;
    },
    shouldUpdateUserLocation() {
      const refs = this.$refs['field-workplace'];
      if ((refs || []).length === 0) {
        return false;
      }
      const [workplaceField] = refs;
      return workplaceField.$children.length > 0
          // check into wordplace component if switch is enabled
          && workplaceField.$children[0].overrideUserWorkplace === true;
    },
    toggleCollapse(id) {
      this.collapsed[id] = !this.collapsed[id];
    },
    handleResize() {
      const contents = document.querySelectorAll('#form-header');

      if (window.matchMedia('(max-width:960px)').matches) {
        if (this.collapsed.whatsappFields) {
          this.toggleCollapse('whatsappFields');
        }
        if (this.collapsed.dirayaFields) {
          this.toggleCollapse('dirayaFields');
        }
        // if (this.collapsed.phoneFields) {
        //  this.toggleCollapse('phoneFields');
        // }
        // if (this.collapsed.personalInfo) {
        //   this.toggleCollapse('personalInfo');
        // }
        for (let i = 0; i < contents.length; i += 1) {
          contents[i].classList.add('element-collapse');
        }
      } else {
        if (!this.collapsed.whatsappFields) {
          this.toggleCollapse('whatsappFields');
        }
        if (!this.collapsed.dirayaFields) {
          this.toggleCollapse('dirayaFields');
        }
        if (!this.collapsed.phoneFields) {
          this.toggleCollapse('phoneFields');
        }
        // if (!this.collapsed.personalInfo) {
        //   this.toggleCollapse('personalInfo');
        // }
        for (let i = 0; i < contents.length; i += 1) {
          contents[i].classList.remove('element-collapse');
        }
      }
    },
    async peticionMaco() {
      this.loading = true;
      const { userid } = this.$store.getters['session/user'];
      const response = await this.macoClient.getPermisosMaco({
        apiCges: {
          delegado: userid,
          endpoint: `maco/operadores/${ userid }/roles`,
        },
      });
      this.treeData = this.setItemArray(response.collection_maco);
      this.loading = false;
    },
    async getFechaPassCaduca() {
      const fecha = this.userData.fechaPassCaduca;
      if (fecha) {
        const fechaCaduca = this.formatedDate(fecha);
        const days = this.calculateDate(fecha);
        if (days && fecha.status !== 500) {
          // eslint-disable-next-line no-param-reassign
          const stringFecha = `${ fechaCaduca } (faltan ${ days } días)`;
          return stringFecha;
        }
      }

      this.showPass = false;
      return '';
    },
    setItemArray(allPermisos) {
      if (allPermisos !== undefined) {
        const { permisosMaco } = allPermisos;
        const arrayTree = [];
        permisosMaco.forEach((element) => {
          const type = element.recurso.extension[0].url;
          const subTypes = element.recurso.codigo[0];
          const treeObj = {};
          if (element.recurso.extension.length > 1) {
            console.error('ERROR');
          } else {
            const lastChildren = [];
            // eslint-disable-next-line no-unused-expressions
            type === 'ModuloMaco'
              ? (treeObj.name = `${element.recurso.extension[0].codificacionValores.texto}`)
              : null;
            // eslint-disable-next-line no-unused-expressions
            type === 'ModuloMaco'
              ? (treeObj.class = 'element111')
              : null;
            if (subTypes.extension.length > 1) {
              let labelString = '';
              const isInstalacion = subTypes.extension.find((o) => o.url === 'Instalacion');
              if (isInstalacion) {
                let endOf = '';
                let mainString = '';
                subTypes.extension.forEach((sub) => {
                  // eslint-disable-next-line no-unused-expressions
                  sub.url === 'Instalacion'
                    ? (mainString = `Ámbito + Unidad funcional: ${sub.codificacionValores.texto} `)
                    : (endOf = `- ${sub.codificacionValores.texto}`);
                });
                mainString += endOf;
                labelString = mainString;
              }
              // eslint-disable-next-line no-unused-expressions
              subTypes.codificacion.length > 1
                ? subTypes.codificacion.forEach((cod) => {
                  lastChildren.push({
                    name: `Perfil - ${cod.texto}`,
                  });
                })
                : lastChildren.push({
                  name: `Perfil - ${subTypes.codificacion[0].texto}`,
                });
              treeObj.children = [{ name: labelString, children: lastChildren }];
              arrayTree.push(treeObj);
            } else {
              const labelString = `Ámbito/Unidad funcional - ${subTypes.extension[0].codificacionValores.texto}`;
              // eslint-disable-next-line no-unused-expressions
              subTypes.codificacion.length > 1
                ? subTypes.codificacion.forEach((cod) => {
                  lastChildren.push({
                    name: `Perfil - ${cod.texto}`,
                  });
                })
                : lastChildren.push({
                  name: `Perfil - ${subTypes.codificacion[0].texto}`,
                });
              treeObj.children = [{ name: labelString, children: lastChildren }];
              arrayTree.push(treeObj);
            }
          }
        });
        return arrayTree;
      }
      return [];
    },
    formatedDate(date) {
      const fechaOriginal = new Date(date);
      const dia = fechaOriginal.getUTCDate();
      const mes = fechaOriginal.getUTCMonth() + 1;
      const ano = fechaOriginal.getUTCFullYear();
      const diaFormateado = dia.toString().padStart(2, '0');
      const mesFormateado = mes.toString().padStart(2, '0');
      const fechaFormateada = `${diaFormateado}/${mesFormateado}/${ano}`;
      return fechaFormateada.toString();
    },
    calculateDate(date) {
      if (date === 'null' || null) {
        return null;
      }
      const fechaActual = new Date();
      const fechaObjetivo = new Date(date);
      const diferenciaEnMilisegundos = fechaObjetivo - fechaActual;
      let diasFaltantes = Math.floor(diferenciaEnMilisegundos / (1000 * 60 * 60 * 24));
      diasFaltantes = diasFaltantes < 0 ? 0 : diasFaltantes;
      return diasFaltantes.toString();
    },
    async modifPass() {
      this.loadingModifPass = true;
      const { userid } = this.userData;
      if (userid) {
        try {
          const response = await this.$api
            .getClient('user')
            .requestUser(userid);

          const { data } = response;
          if (data && data.code) {
            let msgNotifError;
            if (this.$te(`views.agescon.errors.${data.code}`)) {
              msgNotifError = this.$t(`views.agescon.errors.${data.code}`);
            } else {
              msgNotifError = this.$t('views.agescon.errors.default');
            }
            this.$store.dispatch('messages/createNotificationMessage', {
              title: msgNotifError,
              type: 'error',
              dismissible: true,
              timeout: this.$getConst('notifications.timeoutPlus'),
            });
          } else {
            const { collection_cnt: collectionCnt } = data;
            const user = collectionCnt.cnt[0];
            const msgNotif = this.$t(`views.agescon.finishType.${user.type}`, { destination: user.destination });

            this.$store.dispatch('messages/createNotificationMessage', {
              title: msgNotif,
              icon: 'mdi-check',
              type: 'success',
              dismissible: true,
              timeout: this.$getConst('notifications.timeoutPlus'),
            });
          }

          this.loadingModifPass = false;
        } catch (error) {
          const msgNotif = this.$t('views.agescon.errors.default');
          this.$store.dispatch('messages/createNotificationMessage', {
            title: msgNotif,
            type: 'error',
            dismissible: true,
            timeout: this.$getConst('notifications.timeoutPlus'),
          });
          this.loadingModifPass = false;
        }
      } else {
        const msgNotif = this.$t('views.agescon.errors.default');
        this.$store.dispatch('messages/createNotificationMessage', {
          title: msgNotif,
          type: 'error',
          dismissible: true,
          timeout: this.$getConst('notifications.timeoutPlus'),
        });
        this.loadingModifPass = false;
      }
    },
  },

  beforeDestroy() {
    this.$events.destroy(`form-${this.id}`);
    window.removeEventListener('resize', this.handleResize);
  },
  async created() {
    this.userData = this.$store.getters['session/user'];
    this.macoClient = this.$api.getClient('maco');
    this.userDataClient = this.$api.getClient('user');

    this.fechaPassMovil = await this.getFechaPassCaduca();

    if (this.$props.profileViewForm !== true) {
      this.eventBus.on('form:disableSubmit', (disableSubmit) => {
        this.$props.submitVisible = !disableSubmit;
      });

      this.eventBus.on('form:change', (data) => {
        const dataAll = {
          field: data,
          form: this.getFormDataWithDeleted(),
        };
        this.$root.$emit('UpdateFiledForm', dataAll);
      });
    }
    this.$root.$on('formDisabledBtn', (data) => {
      this.btnDisabled = data;
    });
    await this.peticionMaco();
    this.collapsed.dirayaFields = false;
    // if(!this.collapsed.phoneFields && localStorage.getItem('from') === '/calltome'){
    // this.collapsed.phoneFields = true;
    // }
  },
  mounted() {
    const isMobile = this.$store.getters['globalState/get']('deviceOS') != null;
    if (!isMobile) {
      window.addEventListener('resize', this.handleResize);
    }
    this.handleResize();
  },
};
</script>

  <style lang="scss" scoped>
  .linebreak {
    height: 0;
  }

  .section--divider,
  .linebreak {
    flex-basis: 100%;
  }

  a {
    text-decoration: none;
  }

  p {
    margin: 0;
  }

  .v-expansion-panel {
    background-color: #FFFFFF;
    color: rgba(0, 0, 0, 0.87);
    margin: 10px 4px !important;
    box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%),
      0px 2px 2px 0px rgb(0 0 0 / 14%),
      0px 1px 5px 0px rgb(0 0 0 / 12%) !important;
    max-width: 100%;
    transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
    position: initial !important;
  }

  .v-expansion-panel-header {
    background-color: #ffff;
    width: 100%;
    text-align: left;
    outline: none;
    padding: 16px 24px;
    position: relative;
    transition: 0.3s min-height cubic-bezier(0.25, 0.8, 0.5, 1);
    width: 100%;
    font-size: 0.9375rem;
    line-height: 1;
    border-top-left-radius: inherit;
    border-top-right-radius: inherit;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: start;
  }

  .v-expansion-panel-content {
    display: flex
  }

  .v-expansion-panel-content__wrap {
    padding: 24px 16px;
    flex: 1 1 auto;
    max-width: 100%;
  }

  .element-collapse {
    color: #27846d !important;
    caret-color: #27846d !important;
    border: 1px solid !important;
    border-color: #002060 !important;
  }

  .wrapper__diraya   {
    padding: 0px;
  }

  .btn__pass--style {
    display: flex;
    align-items: end;
  }

  .icon__style:before {
    color: #0747A6 !important;
    font-size: 32px;
  }

  .panelContentSpace {
    padding-top: 3px !important;
    padding-bottom: 3px !important;
    }

  @media (max-width: 960px) {
    .icon__style:before {
      color: #27846d !important;
    }

    .btn__pass {
      width: 100% !important;
    }
    .btn__pass--style {
      display: initial !important;
    }

  }
  .passContent div{
    padding-top: 1.5rem !important;
    padding-left: 0.75rem !important;
    max-height: 56px !important;
  }
  .v-text-field__slot{
    margin-left: 0.75rem !important;
  }
  .inputPass{
    background: rgba(0, 0, 0, 0.06);
    align-items: flex-start;
    display: flex;
    flex: 1 1 auto;
    font-size: 16px;
    letter-spacing: normal;
    max-width: 100%;
    text-align: left;
  }

  </style>
